import { createFileRoute, notFound } from "@tanstack/react-router";
import { productHubSlugs } from "@/lib/productHubConfig";
import ProductHubList from "@/pages/ProductHubList";
import NotFound from "@/pages/NotFound";

const SlugReviews = () => {
  const { slug } = Route.useParams();
  if (productHubSlugs.includes(slug)) return <ProductHubList hubSlug={slug} variant="reviews" />;
  return <NotFound />;
};

export const Route = createFileRoute("/$slug/reviews")({
  beforeLoad: ({ params }) => {
    if (!productHubSlugs.includes(params.slug)) throw notFound();
  },
  component: SlugReviews,
});
